import { enqueueAutoTagTable } from "@/apis/table/route";
import { useTableId } from "@/components/mapping/hooks";
import queries from "@/queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useWorkbookId } from "../use-workbook";
import { notifyAutoTagStartFailure } from "./auto-tag-error";

/**
 * 단일 표 오토태깅을 백그라운드 enqueue. 진행상황은 `useAutoTagStatus` 폴링으로 본다.
 */
export default function useAutoTag() {
  const { data: workbookId } = useWorkbookId();
  const { data: tableId } = useTableId();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["auto-tag", tableId?.tableId],
    mutationFn: async () => {
      if (!workbookId) throw new Error("Workbook ID is not found");
      if (!tableId?.tableId) throw new Error("Table ID is not found");
      return enqueueAutoTagTable(workbookId, tableId.tableId);
    },
    onSuccess: () => {
      if (!workbookId) return;
      toast.success("오토태깅을 시작했습니다.");
      // promise 반환 → status refetch(PENDING 도착)까지 isPending 유지.
      // 안 그러면 202 직후 데이터 기반 잠금이 걸리기 전까지 버튼이 잠깐 풀린다.
      return queryClient.invalidateQueries(
        queries.workbook(workbookId)._ctx.autoTagStatus(),
      );
    },
    onError: notifyAutoTagStartFailure,
  });

  return { mutate, isPending };
}
